import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	blockId: number | string | null;
}

export default class BlockDebugButtonComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/blocks') declare mmBlocksService: Service.ModelManager.Blocks;

	get isShown() {
		return this.currentUserService.hasSpecialPermissions;
	}

	@action
	openDebugPopup() {
		if (this.args.blockId) {
			const blockId = +this.args.blockId;
			this.mmBlocksService.openDebugPopup(blockId);
		}
	}
	<template>
		{{#if this.isShown}}
			<a class="debug-button" {{on "click" this.openDebugPopup}}>
				<CommonUiIconComponent @name="Log" @size="sm" />
			</a>
		{{/if}}
	</template>
}
